import { css } from '@emotion/react'
import type { HTMLAttributes } from 'react'
import toast from 'react-hot-toast'

export interface WIPProps extends HTMLAttributes<HTMLDivElement> {}

export default function WIP({ children, ...props }: WIPProps) {
	return (
		<div
			css={css`
				display: flex;
				align-items: center;
				justify-content: center;
			`}
			{...props}
		>
			🚧 WIP {children}
		</div>
	)
}

export function toastWIP() {
	toast('🚧 WIP')
}
